export var BannerType;

(function (BannerType) {
  BannerType["STANDARD"] = "STANDARD";
  BannerType["NON_STANDARD"] = "NON_STANDARD";
})(BannerType || (BannerType = {}));